import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Anexo } from './../../entity/anexo.model';
import { Component, EventEmitter, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { Capacitadora } from '../../entity/capacitadora.model';
import { Responsavel } from '../../entity/responsavel.model';
import { AnexoCapacitadora } from '../../entity/anexo-capacitadora.model';
import { EnderecoCapacitadora } from '../../entity/endereco-capacitadora.model';
import { HomologacaoCapacitadora } from '../../entity/homologacao-capacitadora.model';
import { BaseCrudComponent } from '../../base/base-crud.component';
import { requiredMaxLength, comparerStringRepeated, ValidCpfORCnpj } from 'app/util/custom.validators';
import { CapacitadoraResponsavel } from '../../entity/capacitadora-responsavel.model';
import { EnderecoTipo, TelefoneTipo } from '../../entity/enumeraveis';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'gerenciamento-capacitadora-crud',
    templateUrl: 'gerenciamento-capacitadora-crud.component.html'
})

export class CrudGerenciamentoCapacitadoraComponent extends BaseCrudComponent {
    controllerName = 'capacitadora';
    classificacaoOptions: SelectItem[] = [];
    ufOptions: SelectItem[] = [];
    codigoCapacitadora: string;
    dataCadastro: Date;
    dataEnvio: Date;
    listaTelefone: any[] = [];

    listaResponsaveis: any[] = [];
    listaEmail: any[] = [];

    listaTipoTelefone: any[] = [];
    listaEndereco: any[] = [];

    listaTipoEndereco: SelectItem[] = [];
    listaTipoLogradouro: SelectItem[] = [];
    listaCidade: SelectItem[] = [];
    listaResumo: any[] = [];
    listaRelatores: SelectItem[] = [];
    uploadedFiles: any[] = [];
    storagedListFiles: any[] = [];
    isValidCidade: boolean;

    capacitadora: Capacitadora = new Capacitadora;
    anexo_capacitadora: AnexoCapacitadora = new AnexoCapacitadora;
    endereco_capacitadora: EnderecoCapacitadora = new EnderecoCapacitadora;
    responsavel: Responsavel = new Responsavel;
    homologacao_capacitadora: HomologacaoCapacitadora = new HomologacaoCapacitadora;

    validateForm: any = false;
    isValid = false;
    stepObject: any;
    cnpj: any;
    isBuscou: boolean;
    controladorFilial: boolean;
    controladorRegistro: boolean;
    isValidCidaden = true;

    disableButton = true;

    justificativa: string;
    listaAnexoRecurso: Anexo[] = [];
    recurso: RecursoFiltro =  new RecursoFiltro();


    @Output() listaEnderecoChange = new EventEmitter<any[]>();

    cadastro = this.formBuilder.group({
        capacitadora: this.formBuilder.group({
            id: [null],
            cnpj: [null, [Validators.required, ValidCpfORCnpj]],
            nome: [null, [Validators.required, requiredMaxLength(100, true)]],
            id_classificacao: [null, Validators.required],
            url: [null, Validators.required],
            observacao: [null, [Validators.maxLength(4000)]],
            id_situacao: [16],
            data_cadastro: [null],
            data_envio: [null],
            codigo: [null]
        }),
        // recurso: this.formBuilder.group({
        //     justificativa: [null],
        // }),
        endereco_capacitadora: this.formBuilder.group({
            data_inclusao: [null],
            tipo_endereco: [null, Validators.required],
            numero: [null, [Validators.required, Validators.min(1), requiredMaxLength(10, true)]],
            bairro: [null, [Validators.required, requiredMaxLength(100, true)]],
            num_cep: [null, [Validators.required, Validators.min(8), comparerStringRepeated]],
            logradouro: [null, Validators.required],
            complemento: [null],
            caixa_postal: [null],
            endereco_postal: [null],
            id_tipo_logradouro: [null, Validators.required],
            id_uf: [null, Validators.required],
            id_cidade: [null, [Validators.required]],
            id_capacitadora: [null],
            flg_principal: [0]
        }),
        emails: this.formBuilder.group({
            e_mail: [null, [Validators.required, Validators.email, requiredMaxLength(100, true)]],
            flg_principal: [null]
        }),
        responsavel: this.formBuilder.group({
            cpf: [null, [Validators.required, ValidCpfORCnpj]],
            nome: [null, [Validators.required, Validators.maxLength(100)]],
            telefone: [null, Validators.required],
            email: [null, [Validators.required, Validators.email, requiredMaxLength(100, true)]],
        }),
        telefones: this.formBuilder.group({
            num_telefone: [null, [Validators.required]],
            tipo_telefone: [null, Validators.required],
            flg_principal: [null],
        }),
        anexo_capacitadora: this.formBuilder.group({
            id: [null]
        }),
        termo_aceite: this.formBuilder.group({
            aceite: [false, [Validators.required]]
        }),
    });

    setStepObject(obj: any) {
        this.stepObject = obj;
    }
    init() {

        if (this.acao !== 'cadastrar') {
            this.observableUtilPanelDoc.setBlockedPanel(true);
        }

        this.service.ListarTodos('cidade').subscribe(data => {
            this.listaCidade = data;
        })
        this.service.ListarTodos('combo/classificacao').subscribe(
            data => this.classificacaoOptions = data
        );
        this.service.ListarTodos('uf').subscribe(
            data => this.ufOptions = data
        );
        this.service.ListarTodos('combo/tipo_logradouro').subscribe(
            data => this.listaTipoLogradouro = data
        );
        this.loadListAsEnum(this.listaTipoEndereco, EnderecoTipo);
        this.loadListAsEnum(this.listaTipoTelefone, TelefoneTipo);

        super.afterLoad();
        super.init();

        this.carregarEndereco();

        this.cadastro.get('endereco_capacitadora.id_uf').valueChanges.subscribe(x => {
            if (x != null) {
                this.service.ListarTodos('cidade', { id_estado: x }).subscribe(data => {
                    this.listaCidade = data;
                })
            }
        });
    }
    carregarEndereco() {
        this.cadastro.get('endereco_capacitadora.num_cep').valueChanges.subscribe(x => {
            const cep = this.limpaCaracterEspecial(x);
            // tslint:disable-next-line: triple-equals
            if (cep.length == 8) {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.ObterCep('cep/buscaCep', cep).subscribe(endereco => {
                    if (endereco != null) {
                        this.cadastro.get('endereco_capacitadora.id_uf').setValue(endereco.id_uf);
                        this.cadastro.get('endereco_capacitadora.logradouro').setValue(endereco.logradouro);
                        this.cadastro.get('endereco_capacitadora.complemento').setValue(endereco.complemento);
                        this.cadastro.get('endereco_capacitadora.bairro').setValue(endereco.bairro);
                        this.cadastro.get('endereco_capacitadora.id_cidade').setValue(endereco.id_cidade);
                    } else {
                        this.cadastro.get('endereco_capacitadora.id_uf').setValue(null);
                        this.cadastro.get('endereco_capacitadora.logradouro').setValue(null);
                        this.cadastro.get('endereco_capacitadora.complemento').setValue(null);
                        this.cadastro.get('endereco_capacitadora.bairro').setValue(null);
                        this.cadastro.get('endereco_capacitadora.id_cidade').setValue(null);
                        this.listaCidade = [];
                        this.showMsgWarn(`CEP não cadastrado na Base de dados dos Correios.`);
                    }
                    this.observableUtilPanelDoc.setBlockedPanel(false);

                },
                    err => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgError(`${err._body}`)
                    });
            }
        });
    }

    afterLoad() {
        if (this.acao !== 'cadastrar') {
            // preenche form
            if (this.obj.anexo_capacitadora != null) {
                this.obj.anexo_capacitadora.forEach(x => {
                    x.show = true;
                    this.uploadedFiles.push(x);
                });
                this.codigoCapacitadora = this.obj.codigo;
                this.dataCadastro = this.obj.data_cadastro;
                this.dataEnvio = this.obj.data_envio;
            }
            this.cadastro.get('capacitadora').patchValue(this.obj);
            this.cadastro.get('capacitadora.data_cadastro').patchValue(this.obj.data_cadastro);
            this.cadastro.get('capacitadora.data_envio').patchValue(this.obj.data_envio);
            this.cadastro.get('termo_aceite.aceite').patchValue(this.obj.aceite);
            this.listaEmail = this.obj.email_capacitadora;
            this.listaEndereco = this.obj.endereco_capacitadora.map(item => {
                if (item.flg_principal === true) {
                    this.controladorFilial = true;
                }
                if (item.cidade != null) {
                    item.id_uf = item.cidade.id_uf;
                }
                return item;
            });
            this.listaTelefone = this.obj.telefone_capacitadora;
            this.listaResponsaveis = this.obj.capacitadora_responsavel.map(item => {
                return item.responsavel;
            });


            this.disableButton = false;

            // Empresa
            this.cadastro.get('capacitadora.nome').enable();
            this.cadastro.get('capacitadora.cnpj').disable();
            this.cadastro.get('capacitadora.id_classificacao').enable();
            this.cadastro.get('capacitadora.url').enable();
            this.cadastro.get('capacitadora.observacao').enable();

            // Endereço
            this.cadastro.get('endereco_capacitadora.num_cep').enable();
            this.cadastro.get('endereco_capacitadora.tipo_endereco').enable();
            this.cadastro.get('endereco_capacitadora.id_tipo_logradouro').enable();
            this.cadastro.get('endereco_capacitadora.logradouro').enable();
            this.cadastro.get('endereco_capacitadora.numero').enable();
            this.cadastro.get('endereco_capacitadora.complemento').enable();
            this.cadastro.get('endereco_capacitadora.bairro').enable();
            this.cadastro.get('endereco_capacitadora.id_uf').enable();
            this.cadastro.get('endereco_capacitadora.id_cidade').enable();
            this.cadastro.get('endereco_capacitadora.caixa_postal').enable();
            this.cadastro.get('endereco_capacitadora.flg_principal').enable();

            // Telefone
            this.cadastro.get('telefones.tipo_telefone').enable();
            this.cadastro.get('telefones.num_telefone').enable();

            // Email
            this.cadastro.get('emails.e_mail').enable();

            // Responsáveis
            this.cadastro.get('responsavel.cpf').enable();
            this.cadastro.get('responsavel.nome').enable();
            this.cadastro.get('responsavel.telefone').enable();
            this.cadastro.get('responsavel.email').enable();

            // Termo de Aceite
            this.cadastro.get('termo_aceite.aceite').enable();

            this.obj.homologacao_capacitadora.map(item => {
                this.service.ListarRelatores('listaRelatoresHomologacao', { query: item.id }).subscribe(
                    data => {
                        this.listaRelatores = data;
                      }
                  );
                this.service.ListarTodos('resumoHomologacao', { query: item.id }).subscribe(
                    data => {
                        this.listaResumo = data;
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    }
                );
            });
        }

        this.observableUtilPanelDoc.setBlockedPanel(false);
        this.cnpj = this.cadastro.get('capacitadora.cnpj').value
    }
    finalizar() {
        const listaLink = location.href.split('/')
        const caminho = listaLink[6];

        this.capacitadora = this.cadastro.get('capacitadora').value;
        this.capacitadora.id = this.cadastro.get('capacitadora.id').value;
        this.capacitadora.nome = this.cadastro.get('capacitadora.nome').value;
        this.capacitadora.id_classificacao = this.cadastro.get('capacitadora.id_classificacao').value;
        this.capacitadora.homologacao_capacitadora = [];
        this.capacitadora.cnpj = this.limpaCaracterEspecial(this.cadastro.get('capacitadora.cnpj').value);

        this.capacitadora.endereco_capacitadora = [];
        this.capacitadora.endereco_capacitadora = this.listaEndereco.map(item => {
            item.num_cep = this.limpaCaracterEspecial(item.num_cep);

            // tslint:disable-next-line: triple-equals
            if (item.flg_principal == undefined) {
                // tslint:disable-next-line: triple-equals
                this.isBuscou == true ? item.flg_principal = false : item.flg_principal = true;
            }
            // tslint:disable-next-line: triple-equals
            if (item.data_inclusao == undefined) {
                item.data_inclusao = new Date();
            }
            item.cidade = null;
            return item;
        });
        this.capacitadora.email_capacitadora = [];
        this.capacitadora.email_capacitadora = this.listaEmail.map(item => {
            // tslint:disable-next-line: triple-equals
            if (item.flg_principal == undefined) {
                // tslint:disable-next-line: triple-equals
                this.isBuscou == true ? item.flg_principal = false : item.flg_principal = true;
            }
            return item;
        });
        this.capacitadora.telefone_capacitadora = [];
        this.capacitadora.telefone_capacitadora = this.listaTelefone.map(item => {
            // tslint:disable-next-line: triple-equals
            if (item.flg_principal == undefined) {
                // tslint:disable-next-line: triple-equals
                this.isBuscou == true ? item.flg_principal = false : item.flg_principal = true;
            }
            return item;
        });

        this.capacitadora.capacitadora_responsavel = this.listaResponsaveis.map(item => {
            const capacitadora_responsavel: CapacitadoraResponsavel = new CapacitadoraResponsavel;
            item.telefone = this.limpaCaracterEspecial(item.telefone);
            item.cpf = this.limpaCaracterEspecial(item.cpf);
            item.data_cadastro = new Date();
            item.num_telefone = this.limpaCaracterEspecial(item.num_telefone);
            capacitadora_responsavel.responsavel = item;
            capacitadora_responsavel.id_capacitadora = this.capacitadora.id;
            return capacitadora_responsavel;
        });
        this.capacitadora.anexo_capacitadora = [];
        this.uploadedFiles.forEach(item => {
            this.capacitadora.anexo_capacitadora.push(item);
        });
        this.capacitadora.aceite = this.cadastro.get('termo_aceite.aceite').value;
        // tslint:disable-next-line: radix
        this.capacitadora.id_lotacao = parseInt(localStorage.getItem('lotacao'));
        // Adicionado data atual na data_inclusao/data_cadastro
        // tslint:disable-next-line: triple-equals
        if (this.acao == 'alterar-responsavel') {
            if (this.listaResponsaveis.length <= 0) {
                this.showMsgError(`É necessário adicionar ao menos um responsavel.`);
            } else {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.Atualizar(this.controllerName, this.capacitadora).subscribe(() => {
                    if (caminho === 'alterar-responsavel-homologacao') {
                        this.router.navigate(['/capacitadora/homologacao-capacitadora'], { relativeTo: this.activatedRoute });
                    } else {
                        this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                    }
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                    super.showMsg('success', 'Mensagem de Sucesso', 'Responsável atualizado com sucesso.');
                },
                    err => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgError(`${err._body}`)
                    });
            }
            return;
        }
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            // tslint:disable-next-line: max-line-length
            message: `Atenção! Ao confirmar esta operação, a Solicitação de Credenciamento será ${this.acao === 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
            Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                if (this.acao === 'cadastrar') {
                    this.service.Adicionar(this.controllerName, this.capacitadora).subscribe(() => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                        this.showMsgSucess('Registro salvo com sucesso.');
                    },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsgError(`${err._body}`);
                        });
                } else {
                    this.service.Atualizar(this.controllerName, this.capacitadora).subscribe(() => {
                        this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgSucess('Registro atualizado com sucesso.');
                    },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsgError(`${err._body}`);
                        });
                }
            }
        });
    }

    buscaRegistro() {

        this.cnpj = this.limpaCaracterEspecial(this.cadastro.get('capacitadora.cnpj').value);
        this.cadastro.get('capacitadora.nome').reset();
        if (this.cadastro.get('capacitadora.cnpj').valid) {
            this.isValidCidade = true;
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.Obter('capacitadora/pesquisarPorCnpj', this.cnpj).subscribe(data => {
                this.cadastro.get('capacitadora.nome').setValue(data.razao_social);
                this.listaTelefone = data.telefone.map(item => {
                    item.num_telefone = item.num_ddd + item.num_telefone
                    return item;
                });
                this.listaEmail = data.email;
                this.listaEndereco = data.endereco.map(item => {
                    if (item.cidade != null) {
                        item.id_uf = item.cidade.id_uf;
                    }
                    return item;
                });

                this.disableButton = false;

                // Empresa
                this.cadastro.get('capacitadora.nome').disable();
                this.cadastro.get('capacitadora.cnpj').disable();
                this.cadastro.get('capacitadora.id_classificacao').enable();
                this.cadastro.get('capacitadora.url').enable();
                this.cadastro.get('capacitadora.observacao').enable();

                // Endereço
                this.cadastro.get('endereco_capacitadora.num_cep').enable();
                this.cadastro.get('endereco_capacitadora.tipo_endereco').enable();
                this.cadastro.get('endereco_capacitadora.id_tipo_logradouro').enable();
                this.cadastro.get('endereco_capacitadora.logradouro').enable();
                this.cadastro.get('endereco_capacitadora.numero').enable();
                this.cadastro.get('endereco_capacitadora.complemento').enable();
                this.cadastro.get('endereco_capacitadora.bairro').enable();
                this.cadastro.get('endereco_capacitadora.id_uf').enable();
                this.cadastro.get('endereco_capacitadora.id_cidade').enable();
                this.cadastro.get('endereco_capacitadora.caixa_postal').enable();
                this.cadastro.get('endereco_capacitadora.flg_principal').enable();

                // Telefone
                this.cadastro.get('telefones.tipo_telefone').enable();
                this.cadastro.get('telefones.num_telefone').enable();

                // Email
                this.cadastro.get('emails.e_mail').enable();

                // Responsáveis
                this.cadastro.get('responsavel.cpf').enable();
                this.cadastro.get('responsavel.nome').enable();
                this.cadastro.get('responsavel.telefone').enable();
                this.cadastro.get('responsavel.email').enable();

                // Termo de Aceite
                this.cadastro.get('termo_aceite.aceite').enable();

                this.isBuscou = true;
                this.controladorFilial = true;
                this.controladorRegistro = true;

                this.observableUtilPanelDoc.setBlockedPanel(false);
            },
                err => {
                    this.isBuscou = false;
                    if (err._body === 'CNPJ já cadastrado.') {
                        this.cadastro.get('capacitadora.cnpj').setValue('');
                        this.cadastro.markAsPristine();
                    }
                    if (err._body === 'CNPJ não encontrado na base de dados do registro. Por favor, preencher o formulário.') {

                        // Habilita botões de adicionar
                        this.disableButton = false;

                        // Empresa
                        this.cadastro.get('capacitadora.nome').enable();
                        this.cadastro.get('capacitadora.id_classificacao').enable();
                        this.cadastro.get('capacitadora.url').enable();
                        this.cadastro.get('capacitadora.observacao').enable();

                        // Endereço
                        this.cadastro.get('endereco_capacitadora.num_cep').enable();
                        this.cadastro.get('endereco_capacitadora.tipo_endereco').enable();
                        this.cadastro.get('endereco_capacitadora.id_tipo_logradouro').enable();
                        this.cadastro.get('endereco_capacitadora.logradouro').enable();
                        this.cadastro.get('endereco_capacitadora.numero').enable();
                        this.cadastro.get('endereco_capacitadora.complemento').enable();
                        this.cadastro.get('endereco_capacitadora.bairro').enable();
                        this.cadastro.get('endereco_capacitadora.id_uf').enable();
                        this.cadastro.get('endereco_capacitadora.id_cidade').enable();
                        this.cadastro.get('endereco_capacitadora.caixa_postal').enable();
                        this.cadastro.get('endereco_capacitadora.flg_principal').enable();

                        // Telefone
                        this.cadastro.get('telefones.tipo_telefone').enable();
                        this.cadastro.get('telefones.num_telefone').enable();

                        // Email
                        this.cadastro.get('emails.e_mail').enable();

                        // Responsáveis
                        this.cadastro.get('responsavel.cpf').enable();
                        this.cadastro.get('responsavel.nome').enable();
                        this.cadastro.get('responsavel.telefone').enable();
                        this.cadastro.get('responsavel.email').enable();

                        // Termo de Aceite
                        this.cadastro.get('termo_aceite.aceite').enable();
                    }
                    super.showMsg('Busca', 'Mensagem de alerta', `${err._body}`)
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                })
        } else {
            super.showMsg('Busca', 'Mensagem de alerta', 'Digite um CNPJ válido');
        }
    }
    limparRegistro() {
        this.cadastro.get('capacitadora.cnpj').reset();
        this.cadastro.get('capacitadora.nome').reset();

        // Desabilita botões de adicionar
        this.disableButton = true;

        // Empresa
        this.cadastro.get('capacitadora.cnpj').enable();
        this.cadastro.get('capacitadora.nome').disable();
        this.cadastro.get('capacitadora.id_classificacao').disable();
        this.cadastro.get('capacitadora.url').disable();
        this.cadastro.get('capacitadora.observacao').disable();

        // Endereço
        this.cadastro.get('endereco_capacitadora.num_cep').disable();
        this.cadastro.get('endereco_capacitadora.tipo_endereco').disable();
        this.cadastro.get('endereco_capacitadora.id_tipo_logradouro').disable();
        this.cadastro.get('endereco_capacitadora.logradouro').disable();
        this.cadastro.get('endereco_capacitadora.numero').disable();
        this.cadastro.get('endereco_capacitadora.complemento').disable();
        this.cadastro.get('endereco_capacitadora.bairro').disable();
        this.cadastro.get('endereco_capacitadora.id_uf').disable();
        this.cadastro.get('endereco_capacitadora.id_cidade').disable();
        this.cadastro.get('endereco_capacitadora.caixa_postal').disable();
        this.cadastro.get('endereco_capacitadora.flg_principal').disable();

        // Telefone
        this.cadastro.get('telefones.tipo_telefone').disable();
        this.cadastro.get('telefones.num_telefone').disable();

        // Email
        this.cadastro.get('emails.e_mail').disable();

        // Responsáveis
        this.cadastro.get('responsavel.cpf').disable();
        this.cadastro.get('responsavel.nome').disable();
        this.cadastro.get('responsavel.telefone').disable();
        this.cadastro.get('responsavel.email').disable();

        // Termo de Aceite
        this.cadastro.get('termo_aceite.aceite').disable();

        this.listaTelefone = [];
        this.listaEmail = [];
        this.listaEndereco = [];
        this.isBuscou = false;
        this.controladorFilial = false;
        this.controladorRegistro = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-capacitadora/crud/gerenciamento-capacitadora-crud.component.ts